<template>
    <footer class="root-element"></footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>